import React, { FC } from 'react';
import { Spin } from 'common/components/Spin';
import { priceFormatter } from 'common/helpers/formatter.helper';
import { IGoodsShort } from 'common/models';
import { Image } from 'common/components';

interface IComponentProps {
  good?: IGoodsShort;
  canBeOpened?: boolean;
  loading?: boolean;
}

export const GoodsCardMin: FC<IComponentProps> = ({ good, canBeOpened, loading = false }) => {
  if (!good) {
    return null;
  }

  return (
    <Spin spinning={loading} small>
      <a
        href={`/good/${good.id}${good.isManuallyAdded ? '?isManuallyAdded=true' : ''}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div
          className="goods-card-min p-6 flex"
          style={{ pointerEvents: good.isAvailableForCustomer && canBeOpened ? 'auto' : 'none' }}
        >
          <div className="mr-6">
            <Image size={80} src={good.images?.[0]} />
          </div>

          <div className="flex direction-column justify-between flex-1" style={{ minHeight: 80 }}>
            <div className="ff-medium fs-xs color-black ellipsis-2" style={{ lineHeight: '20px' }} title={good.name}>
              {good.name}
            </div>

            <div className="flex align-center justify-between">
              <span className="ff-semibold fs-s color-black">{priceFormatter(good.price)}</span>

              <div>
                {good.sellerCode && <span className="ff-medium fs-xs color-dark-grey mr-6">{good.sellerCode}</span>}
                {good.buyerCode && <span className="ff-medium fs-xs color-bright-green">{good.buyerCode}</span>}
              </div>
            </div>
          </div>
        </div>
      </a>
    </Spin>
  );
};
